<template>
  <static-fullscreen-card>
    <template v-slot:header></template>
    <template v-slot:title>
      <v-row class="ma-1">
        <v-btn-toggle v-model="period" mandatory borderless dense class="ml-1" @click="onChangePeriod">
          <v-btn value="1M" @click="onChangePeriod('1M')">
            <span class1="hidden-md-and-down">1 месяц</span>
          </v-btn>
          <v-btn value="3M" class="mx-1" @click="onChangePeriod('3M')">
            <span class1="hidden-md-and-down">3 месяца</span>
          </v-btn>
          <v-btn value="select" @click="showConfig = true">
            <span class1="hidden-md-and-down">Диапазон</span>
          </v-btn>
        </v-btn-toggle>
      </v-row>
    </template>
    <v-card class="ma-0" min-height="500">
      <v-card-title class="secondary white--text py-0">
        <slot name="title"></slot>
        <v-spacer />
      </v-card-title>
      <v-divider />
      <div id="wrapper">
        <div id="chart-line">
          <apexchart type="bar" width1="380" :height="500 - 32" :options="chartOptions1" :series="series1"></apexchart>
        </div>
        <div id="chart-line2">
          <apexchart type="bar" width1="380" :height="500 - 32" :options="chartOptions2" :series="series2"></apexchart>
        </div>
      </div>
    </v-card>
    <portal to="v-main">
      <s-quick-config-dialog v-if="showConfig" v-model="showConfig" :values="{ ds: dateStart, de: dateEnd }" :model="modelConfig" @apply="onSetPeriod($event)" />
    </portal>
  </static-fullscreen-card>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      period: "1M",
      dateStart: null,
      dateEnd: null,
      showConfig: false,
      modelConfig: [
        { name: "datePeriod", title: "Период", type: "daterange", dates: ["ds", "de"], calculated: true },
        { name: "ds", title: "Период", type: "date", hidden: true },
        { name: "de", title: "Период", type: "date", hidden: true },
      ],
      dates: [],
      result: [],
      works: [],
      late: [],
    };
  },
  created() {
    this.onChangePeriod(this.period);
  },
  computed: {
    chartOptions1() {
      let res = {
        chart: {
          id: "res",
          group: "social",
          height: 150,
          type: "line",
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.dates,

        title: { text: "Статистика по покупкам", align: "left", offsetX: 110 },
        yaxis1: [
          {
            seriesName: "result",
            axisTicks: { show: true },
            axisBorder: { show: true, color: "#008FFB" },
            labels: { style: { colors: "#008FFB" } },
            title: { text: "Эффективность", style: { color: "#008FFB" } },
            tooltip: { enabled: true },
          },
        ],
      };
      return res;
    },
    chartOptions2() {
      let res = {
        chart: {
          id: "work",
          group: "social",
          height: 150,
          type: "line",
          stacked: false,
        },
        dataLabels: {
          enabled: false,
        },

        title: { text: "Статистика по покупкам", align: "left", offsetX: 110 },
        labels: this.dates,
        yaxis1: [
          {
            seriesName: "works",
            axisTicks: { show: true },
            axisBorder: { show: true, color: "#00E396" },
            labels: { style: { colors: "#00E396" } },
            title: { text: "Колличество задач", style: { color: "#00E396" } },
          },
        ],
      };
      return res;
    },
    series1() {
      let res = [
        {
          name: "result",
          type: "line",
          data: this.result,
        },
      ];
      return res;
    },
    series2() {
      let res = [
        {
          name: "works",
          type: "column",
          data: this.works,
        },
        {
          name: "late",
          type: "column",
          color: "red",
          data: this.late,
        },
      ];
      return res;
    },
  },
  watch: {
    period(v) {
      //this.fetchData(v);
    },
  },
  methods: {
    async fetchData(v) {
      const url = "/mechti/buying/history";
      //const { ds, de } = { ds: new Date().addDays(-v * 30).date, de: new Date().addDays(1).date };
      console.log(this.dateStart, this.dateEnd);
      let params = {
        filters: {
          AND: [{ date_start: { condition: ">=", value: this.dateStart } }, { date_end: { condition: "<=", value: this.dateEnd } }],
        },
        sort: [{ key: "id", order: "ASC" }],
      };
      let resp = await this.$axios.get(url, { params });
      console.log(resp);
      this.doAnalysis(resp.data.data);
    },
    doAnalysis(data) {
      const c = this.period == "1M" ? 30 : this.period == "3M" ? 90 : 0;
      let status = 281; //закуплен в заказе
      let res = [];
      data.map((d) => {
        let done = d.status_history.find((h) => h.value == status && [281, 203, 204].includes(d.status))?.createdon || null;
        d.date_done = new Date(done).date;
      });
      for (let i = 0; i < c; i++) {
        let date_ = new Date(this.dateStart).addDays(i);
        this.dates.push(date_.date);
        let work = data.filter((d) => {
          if ((new Date(d.date_start) <= date_ && (!d.date_done || new Date(d.date_done) >= date_)) || d.date_done === date_.date) {
            return true;
          }
          return false;
        });
        let done = data.filter((d) => {
          if (d.date_done && d.date_done == date_.date) {
            return true;
          }
          return false;
        });
        let late = done.filter((d) => new Date(d.date_end) < new Date(d.date_done)).length;
        this.works.push(work.length);
        this.late.push(late);
        this.result.push(((work.length ? done.length / work.length : 0) * 100).toFixed(0));
        res.push({
          date: date_.date,
          task_work_count: work.length,
          task_work: work,
          task_done_count: done.length,
          task_done: done,
          late_count: late,
        });
      }
      console.log("res", res);
    },
    async onChangePeriod(e) {
      if (e == "3M") {
        this.dateStart = new Date().addDays(-90).date;
        this.dateEnd = new Date().date;
      }
      if (e == "1M") {
        this.dateStart = new Date().addDays(-30).date;
        this.dateEnd = new Date().date;
      }
      if (e == "select") {
        return;
        console.log(res);
        this.paramsApi.params.ds = new Date().date;
        this.paramsApi.params.de = new Date().addDays(30).date;
      }
      this.fetchData();

      //this.$refs.table.updateData();
    },
    onSetPeriod(e) {
      console.log(e);
      this.dateStart = new Date(e.ds).date;
      this.dateEnd = new Date(e.de).date;
      this.setTitle();
    },
  },
};
</script>
